"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/transfer/style/css");

var _transfer = _interopRequireDefault(require("antd/es/transfer"));

require("antd/es/modal/style/css");

var _modal = _interopRequireDefault(require("antd/es/modal"));

var _react = _interopRequireWildcard(require("react"));

require("./thread.scss");

var _reselect = require("reselect");

var _reactRedux = require("react-redux");

var _lodash = require("lodash");

var selectors = _interopRequireWildcard(require("../../redux/selectors"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

class ThreadMembers extends _react.Component {
  constructor() {
    super(...arguments);
    this.state = {
      targetKeys: this.props.members.filter(m => m.isAssigned).map(m => m.userId.toString()),
      confirmLoading: false
    };

    this.handleOk = async () => {
      this.setState({
        confirmLoading: true
      });
      const {
        handleAssign,
        members
      } = this.props;
      const {
        targetKeys
      } = this.state;
      const assignKeys = targetKeys.map(key => parseInt(key));

      const unassignKeys = _lodash._.difference(members.filter(m => m.isAssigned).map(m => m.userId), assignKeys);

      await handleAssign(assignKeys, unassignKeys).then(res => {
        this.setState({
          confirmLoading: false
        });
        this.props.close();
      });
    };

    this.handleCancel = () => {
      this.props.close();
    };

    this.handleChange = (nextTargetKeys, direction, moveKeys) => {
      this.setState({
        targetKeys: nextTargetKeys
      });
    };

    this.mapAdminUserToTransferItem = user => {
      return {
        key: user.id.toString(),
        title: `${user.firstName} ${user.lastName}`
      };
    };
  }

  render() {
    const {
      visible,
      admin
    } = this.props;
    const {
      confirmLoading,
      targetKeys
    } = this.state;
    const dataSource = admin ? admin.map(this.mapAdminUserToTransferItem).sort((a, b) => a.title.localeCompare(b.title)) : [];
    return /*#__PURE__*/_react.default.createElement(_modal.default, {
      destroyOnClose: true,
      closable: false,
      centered: true,
      title: "Assign/Unassign",
      visible: visible,
      okText: "Submit",
      onOk: this.handleOk,
      onCancel: this.handleCancel,
      confirmLoading: confirmLoading
    }, /*#__PURE__*/_react.default.createElement(_transfer.default, {
      dataSource: dataSource,
      showSearch: false,
      showSelectAll: false,
      titles: ['Unassigned', 'Assigned'],
      operations: ['Assign', 'Unassign'],
      targetKeys: targetKeys,
      onChange: this.handleChange,
      render: item => `${item.title}`
    }));
  }

}

const mapStateToProps = (0, _reselect.createStructuredSelector)({
  admin: selectors.getAdmin
});

var _default = (0, _reactRedux.connect)(mapStateToProps)(ThreadMembers);

exports.default = _default;